import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// TODO: react-query 버전 불일치로 인해 버전 다운그레이드 후 사용
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useState } from 'react'

const QueryProvider = ({ children }: React.PropsWithChildren) => {
  // @desc: query 글로벌 설정
  const defaultQueryConfig = {
    refetchOnWindowFocus: true,
    retry: false,
  }

  // @desc: mutation 글로벌 설정
  // const defaultMutationConfig = { throwOnError: true }

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: defaultQueryConfig,
        },
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
}

export default QueryProvider
